import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from '@/shared/auth/AuthContext';
import { RoleGuard } from '@/routes/RoleGuard';
import LoginPage from './pages/LoginPage';
import HealthPage from './pages/HealthPage';
import CuidadorDashboard from '@/roles/cuidador/CuidadorDashboard';
import UsuarioApp from '@/roles/usuario/UsuarioApp';
import AdminDashboard from '@/roles/admin/AdminDashboard';
import { isMasterEmail } from '@/shared/firebase/admin';
import InstallButton from '@/shared/components/InstallButton';

function HomeRedirect() {
  const { isAuthenticated, loading, user, accessCode } = useAuth();
  if (loading) return null;
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  if (isMasterEmail(user?.email)) return <Navigate to="/admin" replace />;
  if (accessCode) return <Navigate to={`/${accessCode.role}`} replace />;
  return <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <InstallButton />
      <Routes>
        <Route path="/" element={<HomeRedirect />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/_health" element={<HealthPage />} />
        <Route path="/cuidador" element={<RoleGuard expected="cuidador"><CuidadorDashboard /></RoleGuard>} />
        <Route path="/usuario"  element={<RoleGuard expected="usuario"><UsuarioApp /></RoleGuard>} />
        <Route path="/admin"    element={<RoleGuard expected="admin"><AdminDashboard /></RoleGuard>} />

        {/* Redirecciones legacy */}
        <Route path="/cuidado"   element={<Navigate to="/usuario" replace />} />
        <Route path="/residente" element={<Navigate to="/usuario" replace />} />
        <Route path="/familiar"  element={<Navigate to="/" replace />} />
        <Route path="/select"    element={<Navigate to="/" replace />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AuthProvider>
  );
}
